import { piniaAuthRouterMiddleware } from '@onereach/auth-ui-module';
import { createPermissionsMiddleware } from '@onereach/permissions-ui';
import { createRouter, createWebHistory } from 'vue-router';

import config from '@/config';
import { useAuth } from '@/stores';

import routes from './routes';

const permissionsMiddleware = createPermissionsMiddleware();

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: '!typography-body-2-bold bg-primary-opacity-0-08 dark:bg-primary-opacity-0-08-dark md:rounded-md',
  routes,
});

router.beforeEach(async (to) => {
  const authStore = useAuth();
  await piniaAuthRouterMiddleware(to, authStore, config.AUTH_UI_URL);

  if (to.meta.requiresAuth && authStore.authorized) {
    return permissionsMiddleware(to);
  }
});

export default router;
